import styled from "styled-components";

export const ProductWarranteeStyled = styled.div`
  .product_warrantee_container {
    padding: 0 27px;
    .warrantee_title {
      margin-bottom: 13px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .img_wrap {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      .product_img {
        max-width: 108px;
        max-height: 100px;
        height: auto;
        margin-bottom: 8px;
      }
    }
    .title {
      margin-bottom: 7px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .pw_status {
      margin-bottom: 10px;
      width: 100%;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      text-align: center;
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      border-radius: 50px;
      background-color: ${({ status }) =>
        status === "Waiting"
          ? "#FEDB04"
          : status === "Approved"
            ? "#0FB863"
            : status === "Expired"
              ? "#95909A"
              : "#FFD700"};
    }
    .pw_row {
      display: flex;
      column-gap: 16px;
      &.block {
        display: block;
      }
      .label {
        margin-bottom: 5px;
        flex-basis: calc(50% - 8px);
        color: ${({ theme }) => theme.COLORS.BLACK_4};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
      .value {
        flex-basis: calc(50% - 8px);
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        &.flex {
          display: flex;
          column-gap: 20px;
        }
      }
      .pw_status {
        border-radius: 10px;
        min-width: 82px;
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${({ statusBg }) => statusBg};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S10};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
    }
    .btn_edit_pw {
      margin-top: 4px;
      border-radius: 12px;
      width: fit-content;
      padding: 0 12px;
      background: ${({ theme }) => theme.COLORS.RED_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      cursor: pointer;
    }
    .pn_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .label {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
      .detail_btn {
        width: 110px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
    }
  }

  .theme_standard {
  }
`;
